import {DraftSortDirection} from 'src/openapi/admin/models/DraftSortDirection';
import {DraftSortField} from 'src/openapi/admin/models/DraftSortField';
import {SortDirection} from 'src/openapi/admin/models/SortDirection';

import type {SsoAccountsFilters, SsoAccountsSearch} from '../models/typedef';
import type {CacheKeys} from 'src/hooks/common-data-service/cached-table';
import type {SsoDraftSearchCriteria} from 'src/openapi/admin/models/SsoDraftSearchCriteria';

const toOffsetDateTimeStart = (date?: string) => date ? `${date}T00:00:00.000Z` : undefined;
const toOffsetDateTimeEnd = (date?: string) => date ? `${date}T23:59:59.999Z` : undefined;
const toDraftSortDirection = (direction?: SortDirection) => (
    direction === SortDirection.ASC ? DraftSortDirection.ASC : DraftSortDirection.DESC
);

export const buildSsoDraftSearchCriteria = (
    cacheKeys: CacheKeys<SsoAccountsSearch, DraftSortField, SsoAccountsFilters>,
): SsoDraftSearchCriteria => {
    const accountQuery = cacheKeys.searchCriteria.accountQuery?.trim().slice(0, 200);
    const filters = cacheKeys.filters as SsoAccountsFilters;
    const {
        createdFrom,
        createdTo,
        finishedFrom,
        finishedTo,
        ...otherFilters
    } = filters;
    const sortField = cacheKeys.sortCriteria.field || DraftSortField.CREATED_AT;
    const sortDirection = cacheKeys.sortCriteria.field
        ? toDraftSortDirection(cacheKeys.sortCriteria.direction)
        : DraftSortDirection.DESC;

    return {
        page: cacheKeys.pagination.currentPage,
        size: cacheKeys.pagination.pageSize,
        sortField,
        sortDirection,
        ...(accountQuery ? {accountQuery} : {}),
        ...otherFilters,
        ...(createdFrom ? {createdFrom: toOffsetDateTimeStart(createdFrom)} : {}),
        ...(createdTo ? {createdTo: toOffsetDateTimeEnd(createdTo)} : {}),
        ...(finishedFrom ? {finishedFrom: toOffsetDateTimeStart(finishedFrom)} : {}),
        ...(finishedTo ? {finishedTo: toOffsetDateTimeEnd(finishedTo)} : {}),
    };
};
